import request from '@/service/lib/request'

/**
 * 气象监测站 - 列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function list(params) {
  return request({
    url: '/api/v1/meteorology/statistic',
    method: 'get',
    params
  })
}

/**
 * 气象监测站 - 列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function cols(id) {
  return request({
    url: `/api/v1/meteorology/devices/${id}/cols`,
    method: 'get'
  })
}
